 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Auth":"Auth","Catalogues~DatasetDetails~DatasetDetailsCategories~DatasetDetailsDataset~DatasetDetailsSimilarDatase~b6faea96":"Catalogues~DatasetDetails~DatasetDetailsCategories~DatasetDetailsDataset~DatasetDetailsSimilarDatase~b6faea96","Catalogues~Datasets":"Catalogues~Datasets","Catalogues":"Catalogues","DatasetDetails":"DatasetDetails","DatasetDetailsCategories":"DatasetDetailsCategories","DatasetDetailsDataset~Datasets~MapBasic":"DatasetDetailsDataset~Datasets~MapBasic","Datasets":"Datasets","DatasetDetailsDataset":"DatasetDetailsDataset","DatasetDetailsSimilarDatasets":"DatasetDetailsSimilarDatasets","Helo":"Helo","UploadPageDatasetDetails":"UploadPageDatasetDetails","UploadPageDistributions":"UploadPageDistributions","UploadPageFileUpload":"UploadPageFileUpload","MapBasic":"MapBasic","Home":"Home","Imprint":"Imprint","PrivacyPolicy":"PrivacyPolicy","UploadPage":"UploadPage","UploadPageReview":"UploadPageReview","bottom":"bottom","MapBoundsReceiver":"MapBoundsReceiver"}[chunkId]||chunkId) + "." + {"Auth":"1e6262dd","Catalogues~DatasetDetails~DatasetDetailsCategories~DatasetDetailsDataset~DatasetDetailsSimilarDatase~b6faea96":"ee297ef5","Catalogues~Datasets":"56f3dae5","Catalogues":"4f81a309","DatasetDetails":"69b95a9e","DatasetDetailsCategories":"6cc287fe","DatasetDetailsDataset~Datasets~MapBasic":"3fadf1a3","Datasets":"f61d3180","DatasetDetailsDataset":"09227b79","DatasetDetailsSimilarDatasets":"bbe994be","Helo":"3e22bc77","UploadPageDatasetDetails":"5d95b4bd","UploadPageDistributions":"2630d9e2","UploadPageFileUpload":"aac6fdf0","MapBasic":"d1f8d1b2","Home":"056c8119","Imprint":"e1cb3728","PrivacyPolicy":"0c7937fc","UploadPage":"848e7228","UploadPageReview":"491a6eed","bottom":"18829e53","chunk-322384ba":"72b53b51","MapBoundsReceiver":"6b444139"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Auth":1,"Catalogues~Datasets":1,"Catalogues":1,"DatasetDetails":1,"DatasetDetailsCategories":1,"DatasetDetailsDataset~Datasets~MapBasic":1,"Datasets":1,"DatasetDetailsDataset":1,"DatasetDetailsSimilarDatasets":1,"UploadPageDatasetDetails":1,"UploadPageDistributions":1,"UploadPageFileUpload":1,"MapBasic":1,"Home":1,"UploadPage":1,"bottom":1,"chunk-322384ba":1,"MapBoundsReceiver":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Auth":"Auth","Catalogues~DatasetDetails~DatasetDetailsCategories~DatasetDetailsDataset~DatasetDetailsSimilarDatase~b6faea96":"Catalogues~DatasetDetails~DatasetDetailsCategories~DatasetDetailsDataset~DatasetDetailsSimilarDatase~b6faea96","Catalogues~Datasets":"Catalogues~Datasets","Catalogues":"Catalogues","DatasetDetails":"DatasetDetails","DatasetDetailsCategories":"DatasetDetailsCategories","DatasetDetailsDataset~Datasets~MapBasic":"DatasetDetailsDataset~Datasets~MapBasic","Datasets":"Datasets","DatasetDetailsDataset":"DatasetDetailsDataset","DatasetDetailsSimilarDatasets":"DatasetDetailsSimilarDatasets","Helo":"Helo","UploadPageDatasetDetails":"UploadPageDatasetDetails","UploadPageDistributions":"UploadPageDistributions","UploadPageFileUpload":"UploadPageFileUpload","MapBasic":"MapBasic","Home":"Home","Imprint":"Imprint","PrivacyPolicy":"PrivacyPolicy","UploadPage":"UploadPage","UploadPageReview":"UploadPageReview","bottom":"bottom","MapBoundsReceiver":"MapBoundsReceiver"}[chunkId]||chunkId) + "." + {"Auth":"cf82dbbb","Catalogues~DatasetDetails~DatasetDetailsCategories~DatasetDetailsDataset~DatasetDetailsSimilarDatase~b6faea96":"31d6cfe0","Catalogues~Datasets":"9caa41d5","Catalogues":"5daff700","DatasetDetails":"68193333","DatasetDetailsCategories":"df78d524","DatasetDetailsDataset~Datasets~MapBasic":"01cff9e3","Datasets":"29c595d4","DatasetDetailsDataset":"11e86163","DatasetDetailsSimilarDatasets":"3a15507c","Helo":"31d6cfe0","UploadPageDatasetDetails":"e54a9703","UploadPageDistributions":"fd7910b3","UploadPageFileUpload":"0a02c809","MapBasic":"4f930a88","Home":"792c60e1","Imprint":"31d6cfe0","PrivacyPolicy":"31d6cfe0","UploadPage":"f9d65ee7","UploadPageReview":"31d6cfe0","bottom":"15e8d30b","chunk-322384ba":"e343a138","MapBoundsReceiver":"4f930a88"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
